import type {Inlet, Outlet} from "#template/runtime-graph/slots"
import {NotReady} from "#template/runtime-graph/slots"
import {TypeDescriptors} from "#template/runtime-graph/type-descriptors"
import type {NodeClassImpl} from "#template/runtime-graph/types"
import type {LiveValueAccessor} from "#template/interactions"
import type {Vector3} from "@cm/math"

const TD = TypeDescriptors

export class LiveVector3ValueState {
    isInteracting = false
    liveValue: Vector3 | undefined = undefined
}

const liveVector3ValueDescriptor = {
    state: TD.inlet(TD.Identity<LiveVector3ValueState>()),
    value: TD.inlet(TD.Identity<Vector3>()),
    output: TD.outlet(TD.Identity<Vector3>()),
    accessor: TD.outlet(TD.Identity<LiveValueAccessor<Vector3>>()),
}

export class LiveVector3Value implements LiveValueAccessor<Vector3>, NodeClassImpl<typeof liveVector3ValueDescriptor, typeof LiveVector3Value> {
    static descriptor = liveVector3ValueDescriptor
    static uniqueName = "LiveVector3Value"
    state!: Inlet<LiveVector3ValueState>
    value!: Inlet<Vector3>
    output!: Outlet<Vector3>
    accessor!: Outlet<LiveValueAccessor<Vector3>>

    run() {
        if (this.state === NotReady || this.value === NotReady) {
            this.accessor.emitIfChanged(NotReady)
            this.output.emitIfChanged(NotReady)
            return
        }
        this.accessor.emitIfChanged(this)
        this.output.emitIfChanged(this.state.isInteracting && this.state.liveValue !== undefined ? this.state.liveValue : this.value)
    }

    setLiveValue(value: Vector3) {
        if (this.state === NotReady) return
        this.state.isInteracting = true
        this.state.liveValue = value
        this.output.emitIfChanged(value)
    }

    endInteraction() {
        if (this.state === NotReady) return
        this.state.isInteracting = false
        this.state.liveValue = undefined
    }
}
